import database from '@/utils/database'

export default class Character {
  constructor (data) {
    this.data = data
    this.key = data.characterId
  }

  get characterId () {
    return this.data.characterId
  }

  get emblemBackgroundPath () {
    return 'https://www.bungie.net' + this.data.emblemBackgroundPath
  }

  get emblemPath () {
    return 'https://www.bungie.net' + this.data.emblemPath
  }

  get class_ () {
    return database.getClass(this.data.classHash)
  }

  get race () {
    return database.getRace(this.data.raceHash)
  }

  get raceName () {
    return this.race.displayProperties.name
  }

  get className () {
    return this.class_.displayProperties.name
  }

  get gender () {
    return {}
    // return definitions.getGender(this.data.characterBase.genderHash)
  }
  get light () {
    return this.data.light
  }
  get level () {
    return this.data.levelProgression.level
  }
  get isVault () {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/domain/Character.js